import { HEADER_CLICK_IDS } from '../../../types';
import { sendReward } from '@dx-ui/framework-conductrics';
import { NavItemWithPopup } from '../../nav-items';
import {
  dispatchGlobalNavigationClick,
  mapBrandCodeToSubmenuSurface,
} from '../../../header.utilities';
import { useTranslation } from 'next-i18next';
import { DesktopUserPopupContents } from '../navigation-popup-contents';
import { Popup } from '@dx-ui/osc-popup';
import { useHeaderContext } from '../../../context/header-context';
import { useHeaderStateContext } from '../../../context/header-state-context';

export const SignedInUserMenu = () => {
  const [t] = useTranslation(['osc-header', 'osc-login']);
  const {
    brand,
    user: { user, onSignOut },
    features: { shouldOpenAccountLinksInNewWindow, shouldSuppressHonorsAccountLinks },
    visual: { isTranslucent, isReimagineThemeExperience, surfaceType },
    navigation: { onGlobalNavigationClick, isLegacyGlobalNavigationClickAnalyticsEnabled = true },
  } = useHeaderContext();
  const {
    refs: { userButtonLinkRef },
    activeUserLinks,
  } = useHeaderStateContext();

  if (!user) return null;

  return (
    <Popup>
      <NavItemWithPopup
        section="user"
        popupButtonRef={userButtonLinkRef}
        onClick={() => {
          dispatchGlobalNavigationClick(
            HEADER_CLICK_IDS.MemberName,
            onGlobalNavigationClick,
            isLegacyGlobalNavigationClickAnalyticsEnabled
          );
          sendReward('profile-name-click');
        }}
        label={t('greetings', { username: user?.name })}
        icon="user-circle"
        surfaceType={
          isTranslucent
            ? surfaceType
            : mapBrandCodeToSubmenuSurface(brand.code, isReimagineThemeExperience)
        }
        isTranslucent={isTranslucent}
      >
        {!!user && (
          <DesktopUserPopupContents
            user={user}
            userLinks={activeUserLinks}
            shouldOpenAccountLinksInNewWindow={shouldOpenAccountLinksInNewWindow}
            shouldSuppressHonorsAccountLinks={shouldSuppressHonorsAccountLinks}
            onSignOut={onSignOut}
          />
        )}
      </NavItemWithPopup>
    </Popup>
  );
};
